export const NEW_FILE = 'NEW_FILE';